import React from 'react'
import Wrapper from './layout/Wrapper'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'

const Table = styled.table`
  text-align: center;
  border-collapse: collapse;
  font-size: 13px;
  margin-bottom: 40px;

  ${breakpoint('tablet')`
    margin-left: 0;
    margin-right: 0;
    width: 100%;
  `}

  thead {
    font-weight: bold;
  }

  td {
    border-left: solid 1px ${props => props.theme.colors.grisMedio};
    border-right: solid 1px ${props => props.theme.colors.grisMedio};
    height: 90px;

    ${breakpoint('tablet')`
      height: 60px;
    `}
  }

  thead tr:first-child > td:not(:first-child) {
    border-top: solid 1px ${props => props.theme.colors.grisMedio};
  }

  tbody tr:last-child > td:not(:first-child) {
    border-bottom: solid 1px ${props => props.theme.colors.grisMedio};
  }

  tr > td:first-child {
    border: 0;
    font-weight: bold;
  }

  tbody > tr:nth-child(odd) {
    background: ${props => props.theme.colors.grisClaro};
    border-bottom: 1px solid ${props => props.theme.colors.grisClaro};
  }

  tbody > tr:nth-child(even) {
    border-bottom: 1px solid #fff;
  }

  tbody tr:hover > td,
  tbody tr:last-child:hover > td:not(first-child) {
    font-size: 1.2em;
    font-weight: bold;
    border-bottom: solid 1px ${props => props.theme.colors.grisOscuro};
  }
`

const Moneda = styled.div`
  font-size: 11px;
`

const InnerContainer = styled.div`
  ${breakpoint('tablet')`
    display: inline-block;
    width: 50%;
  `}
`

const Tasa = styled.div`
  margin-bottom: 5px;
  font-size: 1.3em;
`

export default ({ rates }) => (
  <Wrapper>
    <Table>
      <thead>
        <tr>
          <td width="20%" />
          <td width="40%">Tasa preferencial mensual</td>
          <td width="40%">Tasa normal mensual</td>
        </tr>
      </thead>
      <tbody>
        {rates.map(color => (
          <tr key={color.id}>
            <td>{color.titulo}</td>
            <td>
              <InnerContainer>
                <Moneda>Colones</Moneda>
                <Tasa>{color.preferencialColones}%</Tasa>
              </InnerContainer>
              <InnerContainer>
                <Moneda>Dólares</Moneda>
                <Tasa>{color.preferencialDolares}%</Tasa>
              </InnerContainer>
            </td>
            <td>
              <InnerContainer>
                <Moneda>Colones</Moneda>
                <Tasa>{color.normalColones}%</Tasa>
              </InnerContainer>
              <InnerContainer>
                <Moneda>Dólares</Moneda>
                <Tasa>{color.normalDolares}%</Tasa>
              </InnerContainer>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  </Wrapper>
)
